import { useFetch } from "~vue/api";
import { logError, logUserInteraction } from "~vue/utils/logUtils";
import { computed, ref } from "vue";

const V1_URL = (hashid) => `/accounts/coaching_session/${hashid}`;
const V2_URL = (uuid) => `/v1/nadia2/conversations/${uuid}`;

/**
 * Composable to delete a past conversation (Nadia 1.0 OR Nadia 2.0).
 *
 * Both kinds use HTTP DELETE; only the URL differs.
 *
 * @param {Object} args
 * @param {Function} args.onResponseCallback - Called after a successful delete.
 * @param {string} args.source - Source identifier, used for analytics.
 */
export const useDeletePastConversation = ({ onResponseCallback, source }) => {
    const activeUrl = ref(null);
    const url = computed(() => activeUrl.value);

    const { execute, onFetchError, onFetchResponse } = useFetch(url, { immediate: false }).delete();
    onFetchError((error) => logError(error));
    onFetchResponse(() => onResponseCallback?.());

    const deletePastConversation = async ({ kind, hashid, uuid }) => {
        activeUrl.value = kind === "v2" ? V2_URL(uuid) : V1_URL(hashid);
        logUserInteraction("delete_conversation", { kind, hashid, uuid, ...(source && { source }) }, uuid);
        await execute();
    };

    return {
        deletePastConversation,
    };
};
